import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Material components
import { Box, Button, Grid, Icon, Typography } from '@material-ui/core';

// Styles 
import useStyles from '../../../../assets/styles/components/cards/itemListProgramCard/itemListProgramCardDetailStyle';

// Constants
import {LANGUAGES} from "../../../../constants/languages";
import {MODALITIES} from "../../../../constants/modalities";

// Icons 
import { ReactComponent as MisCursosLineSVG } from '../../../../assets/images/icons/mis-cursos-line.svg';
import { ReactComponent as CursosLineSVG } from '../../../../assets/images/icons/cursos-line.svg';
import { ReactComponent as ModalidadLineSVG } from '../../../../assets/images/icons/modalidad-line.svg';
import { ReactComponent as Traslate2LineSVG } from '../../../../assets/images/icons/traslate-2-line.svg';

// Components
import PriceAndMembership from '../../components/PriceAndMembership';

const ItemListProgramCardDetail = ({dataDetail, content, membershipIdList, onClickToDetail}) => {
    const classes = useStyles();

    return (
        <Box className={classes.rootItemListProgramCardDetail}> 
            <Box className={classes.dataContainer}>
                <Grid container direction='row'>
                    <Grid item xs={6}>
                        {
                            !!dataDetail.modalityId &&
                            <Box display="flex">
                                <Icon component={ModalidadLineSVG} className={clsx(classes.icon)}/>
                                <Typography className={clsx("variant-xsmall", classes.text)}>{MODALITIES[dataDetail.modalityId]}</Typography>
                            </Box>
                        }
                        {
                            !!dataDetail.documentLabel &&
                            <Box display="flex" pt="4px">
                                <Icon component={MisCursosLineSVG} className={clsx(classes.icon)}/>
                                <Typography className={clsx("variant-xsmall", classes.text)}>{dataDetail.documentLabel}</Typography>
                            </Box>
                        }
                        {
                            !!dataDetail.subjectLength &&
                            <Box display="flex" pt="4px">
                                <Icon component={CursosLineSVG} className={clsx(classes.icon)}/>
                                <Typography className={clsx("variant-xsmall", classes.text)}>{`${dataDetail.subjectLength} materias`}</Typography>
                            </Box>
                        }
                        {
                            !!dataDetail.duration &&
                            <Box display="flex" pt="4px">
                                <Icon className={clsx("ri-film-line", classes.icon)}/>
                                <Typography className={clsx("variant-xsmall", classes.text)}>{`${dataDetail.duration} hr en total`}</Typography>
                            </Box>
                        }
                        {
                            !!dataDetail.language &&
                            <Box display="flex" pt="4px">
                                <Icon component={Traslate2LineSVG} className={clsx(classes.icon)}/>
                                <Typography className={clsx("variant-xsmall", classes.text)}>{LANGUAGES[dataDetail.language ?? "es"]}</Typography>
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={6}>
                        <Box display="flex">
                            <Icon className={clsx("ri-time-line", classes.icon)}/>
                            <Typography className={clsx("variant-xsmall", classes.text)}>Aprende a tu ritmo</Typography>
                        </Box>
                        <Box display="flex" pt="4px">
                            <Icon className={clsx("ri-calendar-check-line", classes.icon)}/>
                            <Box>
                                <Typography className={clsx("variant-xsmall", classes.text)}>No hay periodo de inicio, inicia cuando quieras</Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                <Typography variant="body2" className={clsx("semi-bold", classes.introductionTitle, classes.text)}>Introducción</Typography>
                <Typography className={clsx("variant-xsmall", classes.introductionText, classes.text)}>{dataDetail.description}</Typography>

                <Button color='primary' className={classes.readMoreButton} onClick={onClickToDetail}> <Typography variant="subtitle2" className={clsx()} color='secondary'>Seguir leyendo</Typography></Button>

                <Box className={classes.buttonContainer}> 
                    <Button variant='contained' color='primary' onClick={onClickToDetail} className={classes.buttonGoToProgramDetail}>Ir al programa</Button>
                </Box>
            </Box>
            <Box className={classes.priceAndMembershipContainer}>
                <PriceAndMembership isResponsive={true} content={content} isProgram membershipIdList={membershipIdList} classNameBorderTop={classes.priceAndMembershipTopBorder}/>
            </Box>
        </Box>
    );
};

ItemListProgramCardDetail.propTypes = {
    dataDetail: PropTypes.shape({
        modalityId: PropTypes.number,
        documentLabel: PropTypes.string,
        subjectLength: PropTypes.number,
        duration: PropTypes.number,
        language: PropTypes.string,
        description: PropTypes.string,
    }),
    content: PropTypes.shape({
        price: PropTypes.shape({
            number: PropTypes.number,
            listNumber: PropTypes.number,
        }),
        showLabel: PropTypes.bool.isRequired,
        showPrice: PropTypes.bool.isRequired,
        labelToShow: PropTypes.string.isRequired,
        typeLabel: PropTypes.number.isRequired,
    }).isRequired,
    membershipIdList: PropTypes.arrayOf(PropTypes.number),
    onClickToDetail: PropTypes.func,
};

export default ItemListProgramCardDetail;